
import axios from 'axios';
import Cookies from 'universal-cookie';
const cookies = new Cookies();


export const fetchPurposeApi = async (url: string) => {
    const token =  cookies.get("authToken");

    try{
        const response = await axios.get(`${url}/Purpose/GetAllPurpose`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          return response.data;
    }catch (error) {
        console.error(error);
        return false;
      }
}

export const updatePurposeTypeApi= async (
    url: string,
    id: string,
    name: string,
    hiddenforUser: boolean,
  ) => {
    const token = cookies.get("authToken");
  
    try {
      const response = await axios.post(
        `${url}/Purpose/updatePurpose`,
        {
          Id: id,
          Name: name,
          IsHiddenForUser: hiddenforUser
  
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

export const addPurposeApi= async(
    url: string,
    name: string,
    hiddenforUser: boolean
  )=> {
    const token = cookies.get("authToken");
    const data = {
      url: url,
      Name : name,
      IsHiddenForUser: hiddenforUser
    }
  
    try {
      const response = await axios.post(
        `${url}/Purpose/Create`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error(error);
  
      throw error;
    }
  }
